const MUNCHKIN_ID = "271-BEX-827";
const FORM_ID_PATTERN = /^mktoForm_(\d+)$/;

class MarketoForm {
	constructor(wrapper) {
		this.wrapper = wrapper;
		this.formElement = wrapper.querySelector('form[id^="mktoForm_"]');

		if (!this.formElement) {
			console.error("[MarketoForm] wrapper is missing a `form[id^=\"mktoForm_\"]` child", wrapper);
			return;
		}

		const idMatch = this.formElement.id.match(FORM_ID_PATTERN);
		if (!idMatch) {
			console.error("[MarketoForm] form id does not match mktoForm_<number>:", this.formElement.id);
			return;
		}

		this.formId = Number(idMatch[1]);
		this.dreamdataTrackingId = wrapper.dataset.dreamdataTrackingId || "";

		if (!window.OctopusMarketo) {
			console.error(`[MarketoForm ${this.formId}] window.OctopusMarketo is not available; marketoFormHelper.js must load before this script`);
			return;
		}

		window.OctopusMarketo.initForm({
			munchkinId: MUNCHKIN_ID,
			formId: this.formId,
			onFormReady: (form) => this.onFormReady(form),
			onTimeout: () => {
				console.error(`[MarketoForm ${this.formId}] MktoForms2 did not become ready in time; form will not render`);
			},
		});
	}

	onFormReady(form) {
		const formElement = form.getFormElem()[0];
		if (!(formElement instanceof HTMLElement)) {
			console.error(`[MarketoForm ${this.formId}] getFormElem() did not return an HTMLElement`);
			return;
		}

		window.OctopusMarketo.stripDefaultStyles(formElement);
		this.applyFieldClasses(formElement);
		this.applyButtonClasses(formElement);
		this.removeMarketoArtefacts(formElement);
		this.bindTracking(form);
	}

	applyFieldClasses(formElement) {
		formElement.querySelectorAll(".mktoTextField, .mktoEmailField").forEach((el) => {
			el.classList.add("form-control");
		});
	}

	applyButtonClasses(formElement) {
		// TODO: drop btn/btn-primary once V2 pages load the PU button system.
		formElement.querySelectorAll(".mktoButton").forEach((el) => {
			el.classList.add("btn", "btn-primary", "button", "button--primary");
		});
	}

	removeMarketoArtefacts(formElement) {
		formElement.querySelectorAll(".mktoAsterix, .mktoOffset").forEach((el) => el.remove());
	}

	bindTracking(form) {
		const trackingName = this.resolveTrackingName(form);

		form.onSuccess((values, followUpUrl) => {
			this.reportToDreamdata(trackingName, values);

			if (followUpUrl) {
				location.href = followUpUrl;
				return false;
			}

			return true;
		});
	}

	resolveTrackingName(form) {
		if (this.dreamdataTrackingId) {
			return this.dreamdataTrackingId;
		}

		try {
			const utmCampaign = form.vals()["IM - UTM_Campaign - FC"];
			return utmCampaign ? `${utmCampaign} form` : null;
		} catch (error) {
			console.warn(`[MarketoForm ${this.formId}] could not read UTM campaign field for Dreamdata tracking:`, error);
			return null;
		}
	}

	reportToDreamdata(trackingName, values) {
		if (!trackingName || typeof dreamdata === "undefined") {
			return;
		}

		try {
			dreamdata.track(trackingName);

			const email = values && (values.Email || values.email);
			if (email) {
				dreamdata.identify(null, { email });
			}
		} catch (error) {
			console.warn(`[MarketoForm ${this.formId}] Dreamdata tracking failed:`, error);
		}
	}
}

document.querySelectorAll("[data-marketo-form]").forEach((el) => new MarketoForm(el));
